<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("organize_response") }}</label>
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="organize_table"
                :scrollable="true"
                  scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedOrganizeData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="organize_name"
                  :header="$t('id_operating_name')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')"  headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            organizeDelete = dataTable.data;
                            alertDisplay(organizeDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
            <hr />
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-10">
                <label class="p-mr-2">{{ $t("location_risk_area") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
                  scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col p-mt-3 p-ml-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-9 p-lg-11">
                <label>{{ $t("disaster_type") }}</label>
                <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-1 p-lg-1 p-mt-4">
                <Button
                  @click="disasterTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_disaster == true">{{
              $t("table_validate")
            }}</span>
            <br /><br />
            <label>{{ $t("level_effect") }}</label>
            <div class="p-formgrid p-grid p-col p-mt-3">
              <div class="p-col-12">
                <div class="p-formgrid p-grid">
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_1"
                      name="check_1"
                      value="1"
                      v-model="checked"
                    />
                    <label>{{ $t("level_1") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_2"
                      name="check_2"
                      value="2"
                      v-model="checked"
                    />
                    <label>{{ $t("level_2") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_3"
                      name="check_3"
                      value="3"
                      v-model="checked"
                    />
                    <label>{{ $t("level_3") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_4"
                      name="check_4"
                      value="4"
                      v-model="checked"
                    />
                    <label>{{ $t("level_4") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_5"
                      name="check_5"
                      value="5"
                      v-model="checked"
                    />
                    <label>{{ $t("level_5") }}</label>
                  </div>
                </div>
              </div>

              <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                <div class="p-field p-col p-mt-2">
                  <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green"
                  /> -->
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3"
                  />
                  <Button
                    @click="search()
                    cou= true"
                    :label="$t('searchBtn')"
                    class="p-button-info p-mr-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <!-- :contentStyle="{ 'overflow-y': 'scroll' }" -->
    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ResponseAreaModalHeader')"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
                  scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        ref="dt"
        :exportFilename = "`สรุปจำนวนพื้นที่เสี่ยงภัย-${date}`"
        :rowHover="true"
        :filters="filters"
        :sortOrder="1"
        sortField="index"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
      <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
        <template #header>
          
          <!-- <div class="table-header p-col-6 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div> -->

          <div class="p-grid">
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span> -->

            <!-- Doe ค้นหา  1/5 -->
            <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div hidden>{{ dataTable.data.system_id }}</div>
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>  
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->
        
        <div v-if="columns_disaster == true">
          <Column
            field="disaster"
            :header="$t('disaster_type')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.disaster }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        
        <div v-if="columns_location_name == true">
          <Column
            field="location_name"
            :header="$t('location_risk_area')"
            :sortable="true"
            headerStyle="width: 30rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.location_name != null">
                <div class="p-grid">
                  <!-- {{ dataTable.data.province_name }},
                  {{ dataTable.data.amphur_name }}, -->
                  {{ dataTable.data.location_name }}
                </div>
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_organize_name == true">
          <Column
            field="organize_name"
            :header="$t('organize_response')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.organize_name }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_level == true">
          <Column
            field="level"
            :header="$t('level_effect')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <!-- <div v-if="dataTable.data.level == 'null'">-</div>
              <div v-else>{{ dataTable.data.level }}</div> -->

              <div v-if="dataTable.data.level == '1'" class="table_row">  
                  <div :style="{color: '#fff', backgroundColor:'#00902A', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.level == '2'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#92D14F', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.level == '3'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FCFC25', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.level == '4'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FE7B00', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.level == '5'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FE0000', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>
              <div v-else class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#A09B9B', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.level }}
                  </div>
              </div>

            </template>
          </Column>
          </div>
          <div v-else>
                <Column headerStyle="width: 0"></Column>
          </div>

          <div v-if="columns_amount == true">
          <Column
            field="amount"
            :header="$t('amount_area')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.amount }}
              </div>
              
            </template>
          </Column>
        </div>
          <div v-else>
                <Column headerStyle="width: 0"></Column>
          </div>

          <div v-if="columns_riskarea_lat == true">
            <Column
            field="riskarea_lat"
            :header="`ละติจูด`"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ parseFloat(dataTable.data.riskarea_lat ).toFixed(6)}}
              </div>
              
            </template>
          </Column>
        </div>
          <div v-else>
                <Column headerStyle="width: 0"></Column>
          </div>

        <div v-if="columns_riskarea_lon == true">  
          <Column
            field="riskarea_lon"
            :header="`ลองจิจูด`"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ parseFloat(dataTable.data.riskarea_lon ).toFixed(6)}}
              </div>
              
            </template>
          </Column>
        </div>
          <div v-else>
                <Column headerStyle="width: 0"></Column>
          </div>

      </DataTable>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
import organizeTable from "../OrganizeMultiSelectTable";
import responseAreaTable from "../ResponseAreaTable";
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-risk-area-amount",
  components: {
    organizeTable,
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      table: [],
      filters: {},
      displayConfirmation: false,
      showOrganize: false,
      showResponseArea: false,

      disasterTypeOptions: [],
      disasterTypeSelected: null,

      selectedOrganizeData: null,
      organize_table: [],

      selectedResponseAreaData: null,
      responseArea_table: [],

      organizeDelete: null,
      responseAreaDelete: null,

      checked: [],
      error_disaster: false,

      loading: false,

      parentmessage_organize: null,
      parentmessage_area: null,

      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางสรุปจำนวนพื้นที่เสี่ยงภัย",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:15,
      PDF_FontBodyVer:12,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                          index: {cellWidth: 35},
                          disaster:{cellWidth:90},

                          level:{cellWidth:55},
                          riskarea_latPDF:{cellWidth:60},
                          riskarea_lonPDF:{cellWidth:60},
      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 35},
                          
                          level:{cellWidth:55},
                          riskarea_latPDF:{cellWidth:60},
                          riskarea_lonPDF:{cellWidth:60},  
      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "ประเภทสาธารณภัย", dataKey: "disaster" },
                  {title: "ที่ตั้งพื้นที่เสี่ยงภัย", dataKey: "location_name" },
                  {title: "หน่วยงานรับผิดชอบ", dataKey: "organize_name"},
                  {title: "ระดับความรุนแรง", dataKey: "level"},
                  {title: "จำนวน(พื้นที่)", dataKey: "amount"},
                  {title: "ละติจูด", dataKey: "riskarea_latPDF"},
                  {title: "ลองจิจูด", dataKey: "riskarea_lonPDF"},

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_disaster:true,
      columns_location_name:true,
      columns_organize_name:true,
      columns_level:true,
      columns_amount:true,
      columns_riskarea_lat:true,
      columns_riskarea_lon:true,

      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"หน่วยงานรับผิดชอบ",
          textShow:"",
        },
        {
          DataName:"ที่ตั้งพื้นที่เสี่ยงภัย",
          textShow:"",
        },
        {
          DataName:"ประเภทสาธารณภัย",
          textShow:"",
        },
        {
          DataName:"ระดับความรุนแรง",
          textShow:"",
        },
      ],

      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

                let columns = this.columnsSelector

                const Body_setCenter = ["index","amount","riskarea_latPDF","riskarea_lonPDF"]
                
                const fill_row_detail = [
                {
                  name_row:"level",
                  detail_row:[
                  {
                    check_text:"1",
                    fill_color:[0,144,42]
                  },
                  {
                    check_text:"2",
                    fill_color:[146,209,79]
                  },
                  {
                    check_text:"3",
                    fill_color:[252,252,37]
                  },
                  {
                    check_text:"4",
                    fill_color:[254,123,0]
                  },
                  {
                    check_text:"5",
                    fill_color:[254,0,0]
                  }],
                },
              ]

                const PintPDF = {
                  streak:this.setPDF_Ver,
                  setPosition:this.setPosition_Ver,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderVer,
                  Body_FontSize:this.PDF_FontBodyVer,
                  minCell:this.PDF_minCellWidthVer,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                  // 
                  check_fill_row:true,
                  fill_row_detail:fill_row_detail
                }
                this.printPDF(PintPDF)

              }
            }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
               let columns = this.columnsSelector

                const Body_setCenter = ["index","amount","riskarea_latPDF","riskarea_lonPDF"]
                
                const fill_row_detail = [
                {
                  name_row:"level",
                  detail_row:[
                  {
                    check_text:"1",
                    fill_color:[0,144,42]
                  },
                  {
                    check_text:"2",
                    fill_color:[146,209,79]
                  },
                  {
                    check_text:"3",
                    fill_color:[252,252,37]
                  },
                  {
                    check_text:"4",
                    fill_color:[254,123,0]
                  },
                  {
                    check_text:"5",
                    fill_color:[254,0,0]
                  }],
                },
              ]

                const PintPDF = {
                  streak:this.setPDF_Hor,
                  setPosition:this.setPosition_Hor,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeHorSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderHor,
                  Body_FontSize:this.PDF_FontBodyHor,
                  minCell:this.PDF_minCellWidthHor,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                  // 
                  check_fill_row:true,
                  fill_row_detail:fill_row_detail
                }
                this.printPDF(PintPDF)
            }
          }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },

    showResponseArea(val) {
      if (val == true) {
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },
    disasterTypeOptions(val) {
      if (val != null) {
        this.disasterTypeSelected = val;
      }
    },

    disasterTypeSelected(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.disasterTypeSelected = null;
        }
      }
    },
    table(val) {
      // console.log(val);
      if (val.length > 0) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },

  },
  // async created() {
  //   this.checked = ["1", "2", "3","4","5"];
  //   await this.axios
  //     .post(`${this.$url_service}/initial/option`, {
  //       body: { group: "dg-02" },
  //     })
  //     .then((response) => {
  //       this.disasterTypeOptions = response.data.data;
  //     });
  // },
  async created() {

    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

    this.checked = ["1", "2", "3", "4", "5"];
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterTypeOptions = response.data.data;
      });

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)
  },
  mounted() {},
  methods: {
    exportCSV() {
      if (this.table != "") {
      debugger;
      this.$refs.dt.exportCSV();
      }
    },
    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push(variable[i]);
        }
      }
    },

    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {

          if (item.organize_name == null || item.organize_name == "null") {
                    item.organize_name = "-"
                  }
                  if (item.location_name == null || item.location_name == "null") {
                    item.location_name = "-"
                  }

              return (this.columns_disaster ? item.disaster.includes(this.filter) : "") ||
                 (this.columns_location_name ? item.location_name.includes(this.filter) : "") ||
                 (this.columns_organize_name ? item.organize_name.includes(this.filter) : "") ||
                 (this.columns_level ? item.level.includes(this.filter) : "") ||
                 (this.columns_amount ? item.amount.includes(this.filter) : "") ||
                 (this.columns_riskarea_lat ? item.riskarea_lat.includes(this.filter) : "") ||
                 (this.columns_riskarea_lon ? item.riskarea_lon.includes(this.filter) : "") 

      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      // console.log("this.checked",this.checked)
      this.filter='';
      this.cloneTable=[];
      this.loading = true;
      if (this.disasterTypeSelected != null) {
        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-riskarea",
              subtopic: "get-report-riskarea-amount",
              organize: this.organize_table,
              location: this.responseArea_table,
              disaster: this.disasterTypeSelected,
              level: this.checked,
            },
          })
          .then((response) => {
            this.table = response.data.data
            // Doe ค้นหา  4/6 
            this.cloneTable = response.data.data
            // Doe ค้นหา  4/6 

            // console.log("this.disasterTypeOption ",this.disasterTypeOption);
            // console.log("this.disasterTypeSelected ",this.disasterTypeSelected);
            // console.log("this.checked ",this.checked);
            // console.log('this.table =',this.table);

            // Doe : เพิ่ม ลำดับ 3/4
            for (let i = 0; i < this.table.length; i++) { 
              this.table[i]["index"] =i+1;
              // Doe : เพิ่ม ลำดับ 3/4 จบ
            }

            // Doe ช่องว่างใส่ ขีด
          for (let index = 0; index < this.table.length; index++) {

              if (this.table[index].disaster == null ||
                  this.table[index].disaster == "null" ||
                  this.table[index].disaster == "" ) {
                this.table[index].disaster = "-"
              }
              if (this.table[index].level == null ||
                  this.table[index].level == "null" ||
                  this.table[index].level == "" ) {
                this.table[index].level = "-"
              }
              if (this.table[index].riskarea_lat == null ||
                  this.table[index].riskarea_lat == "null" ||
                  this.table[index].riskarea_lat == "" ) {
                this.table[index].riskarea_lat = "-"
                this.table[index]["riskarea_latPDF"] = "-"
              }else if (this.table[index].riskarea_lat !== "-"){
                this.table[index]["riskarea_latPDF"] = parseFloat(this.table[index].riskarea_lat).toFixed(6)
              }
              if (this.table[index].riskarea_lon == null ||
                  this.table[index].riskarea_lon == "null" ||
                  this.table[index].riskarea_lon == "" ) {
                this.table[index].riskarea_lon = "-"
                this.table[index]["riskarea_lonPDF"] = "-"
              }else if (this.table[index].riskarea_lon !== "-"){
                this.table[index]["riskarea_lonPDF"] = parseFloat(this.table[index].riskarea_lon).toFixed(6)
              }

          }
          // Doe ช่องว่างใส่ ขีด

          this.setSearchText_Footer()

          });
          
          if (this.columns_disabled == true) {
            this.table = this.cloneTable
          }else{
            this.table = []
          }
          
        this.loading = false;
      } else {
        this.table = [];
        this.loading = false;
        if (this.disasterTypeSelected == null) {
          this.error_disaster = true;
        }
      }
    },
    setSearchText_Footer(){
          this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.organize_table.length !== 0 ||
              this.responseArea_table.length !== 0 ||
              this.disasterTypeSelected.length !== 0 ||
              this.checked.length !== 0   ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "หน่วยงานรับผิดชอบ" && this.organize_table.length !== 0){
                  element.textShow = this.setArray_to_Text(this.organize_table,"organize_name")
                }
                if(element.DataName === "ที่ตั้งพื้นที่เสี่ยงภัย" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "ประเภทสาธารณภัย" && this.disasterTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.disasterTypeSelected,"system_name")
                }
                if(element.DataName === "ระดับความรุนแรง" && this.checked.length !== 0){
                  element.textShow = this.setArray_to_Text(this.checked,null)
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      if (this.organizeDelete != null) {
        this.organize_table = this.organize_table.filter(
          (val) => val !== this.organizeDelete
        );
      }
      if (this.responseAreaDelete != null) {
        this.responseArea_table = this.responseArea_table.filter(
          (val) => val !== this.responseAreaDelete
        );
      }
      this.displayConfirmation = false;
      this.organizeDelete = null;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.organize_table = [];
      this.responseArea_table = [];
      this.disasterTypeSelected = null;
      this.checked = [];
      this.error_disaster = false;
      this.multiSelectClearFilerValue +=1;
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.table = [];
      this.cloneTable=[];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },

    // Doe PDF เลือกได้  5/5  
    EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else{
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = this.PDF_BodySize

        this.PDF_minCellWidthHor = 73
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_disaster = false
          this.columns_location_name = false
          this.columns_organize_name = false
          this.columns_level = false
          this.columns_amount = false
          this.columns_riskarea_lat = false
          this.columns_riskarea_lon = false


          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 8){
            
            this.columns_index = true
            this.columns_disaster = true
            this.columns_location_name = true
            this.columns_organize_name = true
            this.columns_level = true
            this.columns_amount = true
            this.columns_riskarea_lat = true
            this.columns_riskarea_lon = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "disaster") {
                this.columns_disaster = true 
              }else if(!getData.includes("disaster")){
                
                this.columns_disaster = false
              }

              if (element == "location_name") {
                this.columns_location_name = true 
              }else if(!getData.includes("location_name")){
                
                this.columns_location_name = false
              }

              if (element == "organize_name") {
                this.columns_organize_name = true 
              }else if(!getData.includes("organize_name")){
                
                this.columns_organize_name = false
              }

              if (element == "level") {
                this.columns_level = true 
              }else if(!getData.includes("level")){
                
                this.columns_level = false
              }

              if (element == "amount") {
                this.columns_amount = true 
              }else if(!getData.includes("amount")){
                
                this.columns_amount = false
              }

              if (element == "riskarea_latPDF") {
                this.columns_riskarea_lat = true
              } else if(!getData.includes("riskarea_latPDF")){
                this.columns_riskarea_lat = false
              }

              if (element == "riskarea_lonPDF") {
                this.columns_riskarea_lon = true 
              }else if(!getData.includes("riskarea_lonPDF")){
                
                this.columns_riskarea_lon = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },

  },
};
</script>

<style scoped>
.table_row{
  text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}

.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
.p-multiselect {
  // min-width: 18rem;
  max-width: 60rem;
  // width: fit-content;
}
@media screen and (max-width: 1540px) {
    .p-multiselect {
        max-width: 40rem !important
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        max-width: 10rem !important
    }
}

.multiselect-custom {
  // Doe PDF เลือกได้
  width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    
  }


  

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
